import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const MobileCtaBar = () => {
  const location = useLocation();
  const [contactInView, setContactInView] = useState(false);

  useEffect(() => {
    if (location.pathname === '/discover') return;
    const target = document.getElementById('contact');
    if (!target) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry) setContactInView(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [location.pathname]);

  if (location.pathname === '/discover') return null;

  const hidden = contactInView;

  return (
    <>
      <div
        data-testid="mobile-cta-bar"
        className="mobile-cta-bar z-50"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 50,
          background: '#0F172A',
          color: '#FFFFFF',
          padding: '0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom, 0px))',
          boxShadow: '0 -8px 24px -8px rgba(15, 23, 42, 0.35)',
          transform: hidden ? 'translateY(110%)' : 'translateY(0)',
          transition: 'transform 280ms cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        <a
          href="/discover"
          style={{
            display: 'block',
            width: '100%',
            textAlign: 'center',
            padding: '0.85rem 1rem',
            borderRadius: '0.75rem',
            background:
              'linear-gradient(135deg, #6366F1 0%, #8B5CF6 50%, #D946EF 100%)',
            color: '#FFFFFF',
            fontWeight: 600,
            fontSize: '1rem',
            textDecoration: 'none',
            letterSpacing: '-0.01em',
            boxShadow: '0 8px 24px -8px rgba(99, 102, 241, 0.55)',
          }}
        >
          Tell us what you&rsquo;re building →
        </a>
      </div>
      <style>{`
        .mobile-cta-bar { display: block; }
        @media (min-width: 768px) {
          .mobile-cta-bar { display: none !important; }
        }
      `}</style>
    </>
  );
};

export default MobileCtaBar;
